import axios from "axios";
const API_URL = "/api/contract-request/";

const request = (contractRequest) => {
  return axios
    .post(API_URL, {
      ...contractRequest,
    })
    .then((response) => {
      return response.data;
    });
};

// #40 - AOC/LOA countersignature (principal-facing).
// A principal's queue of their agency's held requests (scoped to their agency by the API).
const awaitingCountersignature = () =>
  axios.get(`${API_URL}awaiting-countersignature`).then((r) => r.data);

// The Assignor signing URL: a real DocuSign embedded view, or { mock: true }
// outside production so the page shows its stand-in signing action.
const countersignUrl = (id) =>
  axios.get(`${API_URL}${id}/countersign-url`).then((r) => r.data);

// Complete the countersignature (release the hold, open the held ticket(s)).
const countersign = (id) =>
  axios.post(`${API_URL}${id}/countersign`).then((r) => r.data);

const ContractRequestService = {
  request,
  awaitingCountersignature,
  countersignUrl,
  countersign,
};

export default ContractRequestService;
